<template>
  <div class="d-flex-row space-between lg-row-to-col">
    <div class="d-flex-row space-between lg-row-to-col">
      <ChampionRankPicker
        :type="'currentRank'"
        item-key="rankBoosting"
        :title="$t('calculators_common.current_rank')"
        class="flex-5 flex-lg-10"
      />
      <DoubleRight />
      <ChampionRankPicker
        :type="'desiredRank'"
        item-key="rankBoosting"
        :title="$t('calculators_common.desired_rank')"
        class="flex-5 flex-lg-10"
      />
    </div>
  </div>
  <PlatformPicker />
  <ExtraOptionPicker />
  <OptionPicker />
  <ChampionsPicker />
</template>

<script setup>
import OptionPicker from "./pickers/OptionPicker.vue";
import ChampionsPicker from "../commonpickers/ChampionsPicker.vue";
import ExtraOptionPicker from "./pickers/RainbowExtraOptionPicker.vue";
import PlatformPicker from "../commonpickers/PlatformPicker.vue";
// import RankDivisionPicker from "./pickers/RankDivisionPicker.vue";
import ChampionRankPicker from "./pickers/ChampionRankPicker.vue";
import DoubleRight from "~/components/icons/DoubleRight.vue";

const checkoutStore = useCheckoutStore();
const {
  setDetails,
  setPackExtraOptions,
  setServer,
  setPlatform,
  setGameAndPack,
  clearCheckout,
  setCalculating,
} = checkoutStore;

const { getGame, getGamePack, getGameRanks } = useGameStore();

const handleDetails = () => {
  clearCheckout();

  const server = getGame?.servers || [];
  const rpGain =
    getGamePack?.pack_extra_options?.find((op) => op.description == "rpGain") ||
    [];

  const championRank = getGameRanks[getGameRanks.length - 1];

  setDetails({
    currentRankPoints: 1,
    desiredRankPoints: 100,
    // currentRank: championRank.id,
    // desiredRank: championRank.id,
  });

  if (rpGain) {
    setPackExtraOptions({
      rpGain: rpGain.id,
    });
  }
  setServer(server[0]?.id);
  setPlatform({
    platform: 1,
  });
  setGameAndPack({
    game: getGame.id,
    pack: getGamePack.id,
    fullGame: getGame,
    fullPack: getGamePack,
  });
};
handleDetails();
onNuxtReady(() => {
  setCalculating();
});
</script>
